var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{directives:[{name:"tippy",rawName:"v-tippy",value:(_vm.bubbleConfig),expression:"bubbleConfig"}],attrs:{"content":_vm.changedBy},domProps:{"innerHTML":_vm._s(typeof _vm.datetime == 'string' ? _vm.datetime : _vm.formatDate(_vm.datetime))}})
}
var staticRenderFns = []

export { render, staticRenderFns }